export enum TaskTypes {
  Interact = 'Interact',
  Practice = 'Practice',
  Reading = 'Reading',
  ProveIt = 'prove-it',
  DrillIt = 'drill-it',
  LearnIt = 'learn-it'
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/data/models/task-type/task-types.ts